<template>
    <div
        v-if="
            _hasAccess('patient.profile.create') ||
            _hasAccess('patient.record.create') ||
            _hasAccess('client.profile.create') ||
            _hasAccess('inventory.item.create') ||
            _hasAccess('billing.estimate.create') ||
            _hasAccess('billing.invoice.create') ||
            _hasAccess('billing.payment.create')
        "
    >
        <b-nav-item-dropdown
            v-if="isNavHorizontal"
            data-top-right-id="shortcuts"
            id="nav-item-shortcut"
            no-caret
            right
        >
            <template slot="button-content">
                <i
                    class="fas fa-plus-circle"
                    :style="{
                        color: _isEnhancedLayout ? '#457b02' : '#97d14f'
                    }"
                ></i>
                <span class="d-lg-none">Quick Add</span>
            </template>

            <b-dropdown-item
                v-if="
                    _hasAccess('patient.profile.create') &&
                    _.get(subscription, 'is_patient_count')
                "
                @click="displaySubscription"
                data-top-shortcut-id="new-patient"
            >
                <i class="fas fa-plus-circle quick-add"></i>
                New Patient
            </b-dropdown-item>
            <b-dropdown-item
                v-else-if="_hasAccess('patient.profile.create')"
                @click="createNewPatient"
                data-top-shortcut-id="new-patient"
            >
                <i class="fas fa-plus-circle quick-add"></i>
                New Patient
            </b-dropdown-item>

            <b-dropdown-item
                v-if="_hasAccess('patient.record.create')"
                @click.stop="createMedicalNote()"
                data-top-shortcut-id="new-medical-note"
            >
                <i class="fas fa-plus-circle quick-add"></i>
                New Medical Note
            </b-dropdown-item>

            <b-dropdown-item
                v-if="_hasAccess('client.profile.create')"
                href="/view/client/new"
                @click.prevent="goToNewClientPage"
                data-top-shortcut-id="new-client"
            >
                <i class="fas fa-plus-circle quick-add"></i>
                New Client
            </b-dropdown-item>

            <b-dropdown-item
                v-if="_hasAccess('inventory.item.create')"
                href="/view/inventory/item-new"
                @click.prevent="goToNewInventoryItemPage"
                data-top-shortcut-id="new-inventory-item"
            >
                <i class="fas fa-plus-circle quick-add"></i>
                New Inventory Item
            </b-dropdown-item>

            <b-dropdown-item
                v-if="_hasAccess('billing.estimate.create')"
                @click.stop="createEstimate()"
                data-top-shortcut-id="new-estimate"
            >
                <i class="fas fa-plus-circle quick-add"></i>
                New Estimate
            </b-dropdown-item>

            <b-dropdown-item
                v-if="_hasAccess('billing.invoice.create')"
                @click.stop="createInvoice()"
                data-top-shortcut-id="new-invoice"
            >
                <i class="fas fa-plus-circle quick-add"></i>
                New Invoice
            </b-dropdown-item>

            <b-dropdown-item
                v-if="_hasAccess('billing.payment.create')"
                @click.stop="createPayment()"
                data-top-shortcut-id="new-payment"
            >
                <i class="fas fa-plus-circle quick-add"></i>
                New Payment
            </b-dropdown-item>
        </b-nav-item-dropdown>

        <li v-else class="left-option">
            <button @click="$emit('toggle-visibility')" class="option-toggle">
                <i class="fas fa-plus-circle"></i>
                <span>Quick Add</span>
            </button>
            <ul v-if="showOptionMenu" class="option-menu">
                <li
                    v-if="
                        _hasAccess('patient.profile.create') &&
                        _.get(subscription, 'is_patient_count')
                    "
                >
                    <button
                        @click="displaySubscription"
                        data-top-shortcut-id="new-patient"
                        class="option-menu-item"
                    >
                        <i class="fas fa-plus-circle quick-add"></i>
                        <span>New Patient</span>
                    </button>
                </li>
                <li v-else-if="_hasAccess('patient.profile.create')">
                    <button
                        @click="createNewPatient"
                        data-top-shortcut-id="new-patient"
                        class="option-menu-item"
                    >
                        <i class="fas fa-plus-circle quick-add"></i>
                        <span>New Patient</span>
                    </button>
                </li>
                <li v-if="_hasAccess('patient.record.create')">
                    <button
                        @click.stop="createMedicalNote()"
                        data-top-shortcut-id="new-medical-note"
                        class="option-menu-item"
                    >
                        <i class="fas fa-plus-circle quick-add"></i>
                        <span>New Medical Note</span>
                    </button>
                </li>
                <li v-if="_hasAccess('client.profile.create')">
                    <button
                        href="/view/client/new"
                        @click.prevent="goToNewClientPage"
                        data-top-shortcut-id="new-client"
                        class="option-menu-item"
                    >
                        <i class="fas fa-plus-circle quick-add"></i>
                        <span>New Client</span>
                    </button>
                </li>
                <li v-if="_hasAccess('inventory.item.create')">
                    <button
                        href="/view/inventory/item-new"
                        @click.prevent="goToNewInventoryItemPage"
                        data-top-shortcut-id="new-inventory-item"
                        class="option-menu-item"
                    >
                        <i class="fas fa-plus-circle quick-add"></i>
                        <span>New Inventory Item</span>
                    </button>
                </li>
                <li v-if="_hasAccess('billing.estimate.create')">
                    <button
                        @click.stop="createEstimate()"
                        data-top-shortcut-id="new-estimate"
                        class="option-menu-item"
                    >
                        <i class="fas fa-plus-circle quick-add"></i>
                        <span>New Estimate</span>
                    </button>
                </li>
                <li v-if="_hasAccess('billing.invoice.create')">
                    <button
                        @click.stop="createInvoice()"
                        data-top-shortcut-id="new-invoice"
                        class="option-menu-item"
                    >
                        <i class="fas fa-plus-circle quick-add"></i>
                        <span>New Invoice</span>
                    </button>
                </li>
                <li v-if="_hasAccess('billing.payment.create')">
                    <button
                        @click.stop="createPayment()"
                        data-top-shortcut-id="new-payment"
                        class="option-menu-item"
                    >
                        <i class="fas fa-plus-circle quick-add"></i>
                        <span>New Payment</span>
                    </button>
                </li>
            </ul>
        </li>

        <b-container fluid>
            <createMedicalNote ref="createMedicalNoteWindow" />
        </b-container>
        <b-container fluid>
            <createEstimate ref="createEstimateWindow" />
        </b-container>
        <b-container fluid>
            <createInvoice ref="createInvoiceWindow" />
        </b-container>
        <b-container fluid>
            <createPayment ref="createPaymentWindow" />
        </b-container>
        <b-container fluid>
            <new-patient-modal
                show-add-new
                enable-record-sharing
                ref="newPatientModal"
                @saved="newPatientSaved"
            />
        </b-container>
    </div>
</template>

<style lang="scss" scoped>
#nav-item-shortcut {
    .fas.quick-add {
        margin-right: 3px;
        color: #678f35;
    }
}
</style>

<script>
import CreateMedicalNote from "../soap/create.vue";
import CreateEstimate from "@/components/client-estimates/estimate-new-modal.vue";
import CreateInvoice from "@/components/new-invoice/invoice-modal";
import CreatePayment from "@/components/new-payment/payment-modal.vue";
import NewPatientModal from "@/module/commons/patient/modal.vue";

export default {
    components: {
        CreateMedicalNote,
        CreateEstimate,
        CreateInvoice,
        CreatePayment,
        NewPatientModal
    },
    data() {
        return {
            subscription: null,
            USE_CLIENT_MODULE_VUE: process.env.USE_CLIENT_MODULE_VUE === "true"
        };
    },
    mounted() {
        this._getSubscription().then(data => {
            this.subscription = data;
        });
    },
    props: {
        isNavHorizontal: {
            type: Boolean,
            default: true
        },
        showOptionMenu: {
            type: Boolean,
            default: false
        }
    },
    computed: {},
    methods: {
        createMedicalNote() {
            if (!this.isNavHorizontal) {
                this._toggleEnhancedLayoutMobileSideMenu();
            }

            this.$refs.createMedicalNoteWindow.open();
        },
        createEstimate() {
            if (!this.isNavHorizontal) {
                this._toggleEnhancedLayoutMobileSideMenu();
            }

            this.$refs.createEstimateWindow.open();
        },
        createInvoice() {
            if (!this.isNavHorizontal) {
                this._toggleEnhancedLayoutMobileSideMenu();
            }

            this.$refs.createInvoiceWindow.open();
        },
        createPayment() {
            if (!this.isNavHorizontal) {
                this._toggleEnhancedLayoutMobileSideMenu();
            }

            this.$refs.createPaymentWindow.open();
        },
        displaySubscription() {
            if (!this.isNavHorizontal) {
                this._toggleEnhancedLayoutMobileSideMenu();
            }

            this.$root.$emit("display-subscription");
        },
        goToNewClientPage() {
            if (!this.isNavHorizontal) {
                this._toggleEnhancedLayoutMobileSideMenu();
            }

            this.$router.push("/client/new");
        },
        goToNewInventoryItemPage() {
            if (!this.isNavHorizontal) {
                this._toggleEnhancedLayoutMobileSideMenu();
            }

            this.$router.push("/inventory/item-new");
        },
        createNewPatient() {
            if (!this.isNavHorizontal) {
                this._toggleEnhancedLayoutMobileSideMenu();
            }

            this.$refs.newPatientModal.open();
        },
        newPatientSaved(patient) {
            this.$router.push({
                name: "patient_profile",
                params: { id: patient.encoded_id || patient.encodedId }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.left-option {
    width: 100%;

    button {
        border: 0;
        outline: 0;
        background: transparent;
        width: 100%;
        font-weight: 500;

        &:hover {
            background: rgba(255, 255, 255, 0.2);
        }

        &:focus-visible {
            box-shadow: 0 0 0 0 #fff,
                0 0 0 calc(2px + 0px) rgba(59, 130, 246, 0.5), 0 0 #0000;
        }
    }

    .option-toggle {
        display: flex;
        gap: 10px;
        height: 36px;
        align-items: center;
        justify-content: start;
        padding: 8px 12px;
        border-radius: 4px;
        color: white;

        span {
            font-size: 0.875rem;
            flex-grow: 1;
            text-align: start;
        }

        .fa-plus-circle {
            color: #97d14f;
        }
    }

    .option-menu {
        display: flex;
        flex-direction: column;
        margin: 4px 0 4px 0;
        padding: 4px 0;
        list-style: none;
        border-radius: 4px;
        background: #fff;

        .fa-plus-circle {
            color: #457b02;
        }
    }

    .option-menu-item {
        display: flex;
        gap: 8px;
        align-items: center;
        padding: 8px 12px 8px 38px;

        &:hover {
            background: #c9ccde;
        }

        span {
            font-size: 0.85rem;
        }
    }
}
</style>
